import CloudDoneOutlinedIcon from "@mui/icons-material/CloudDoneOutlined";
import { DataGridPro, GridValueGetterParams } from "@mui/x-data-grid-pro";
import { Link } from "react-router-dom";
import { useQueryEnvironmentsQuery } from "../../backend/hooks/interactive/queryListEnvironments";
import { Environment, EnvironmentState } from "../../backend/interactiveTypes";
import { PmxActivity } from "../../backend/types";
import {
  priceCalculationPerHour,
  formatStringToDateTime
} from "../../helpers/stringHelper";
import { useAuth } from "../authContextProvider";
import { useGetMyPmxActivitiesLazyQuery } from "../../backend/hooks/pmxActivity/queryGetMyPmxActivities";
import { useEffect } from "react";
import Error from "../abstractComponents/error";

export function LandingPageInteractiveEnvironments({
  activityId,
  myInteractiveEnvironments = true
}: {
  activityId?: number;
  myInteractiveEnvironments?: boolean;
}) {
  const { decodedToken } = useAuth();
  const { environments, isLoadingEnvironments, errorListEnvironments } =
    useQueryEnvironmentsQuery(
      activityId,
      true,
      undefined,
      50,
      null,
      myInteractiveEnvironments ? decodedToken["email"] : undefined
    );

  const { getMyPmxActivities, activities, errorActivities } =
    useGetMyPmxActivitiesLazyQuery();

  useEffect(() => {
    if (environments.length > 0) {
      getMyPmxActivities({
        variables: {
          ids: environments.map(
            (environment: Environment) => environment.activityId
          )
        }
      });
    }
  }, [environments]);

  const columns = [
    { field: "environmentId", headerName: "Environment ID", hide: true },
    {
      field: "environmentName",
      headerName: "Environment Name",
      flex: 4,
      renderCell: (params: GridValueGetterParams) => (
        <div key={params.row.environmentId} className="w-100">
          <div className="button_without_text_transform float-start">
            <Link
              className="interactive_link"
              to={`/activity/${params.row.activityId}/interactive/${params.row.environmentId}`}
            >
              <CloudDoneOutlinedIcon /> {params.row.environmentName}
            </Link>
          </div>
        </div>
      )
    },
    {
      field: "instanceType.instanceTypeId",
      headerName: "Instance Type",
      flex: 1
    },
    {
      field: "state",
      headerName: "State",
      flex: 1
    },
    {
      field: "price",
      flex: 1,
      headerName: "Price",
      valueGetter: (params: GridValueGetterParams) =>
        params.row.state === EnvironmentState.Running
          ? `€${Math.round(
              priceCalculationPerHour(params.row.instanceType.instanceTypeId) *
                24
            )}/Day`
          : "N/A"
    },
    {
      field: "activityId",
      headerName: "Activity",
      flex: 1,
      renderCell: (params: GridValueGetterParams) => {
        const activity = activities?.getMyPmxActivities?.find(
          (activity: PmxActivity) =>
            Number(activity.id) === Number(params.row.activityId)
        );
        return (
          <Link
            className="activity_link"
            to={`/activity/${params.row.activityId}`}
          >
            {activity?.trialNumber ?? params.row.activityId}
          </Link>
        );
      }
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) =>
        formatStringToDateTime(params.row.createdAt)
    }
  ];

  return (
    <>
      {" "}
      <DataGridPro
        rows={environments}
        columns={columns}
        pageSize={10}
        rowHeight={60}
        getRowId={(row) => row.environmentId}
        autoHeight
        disableSelectionOnClick
        className="choose_interactive_list"
        loading={isLoadingEnvironments}
      />
      {(errorListEnvironments || errorActivities) && (
        <Error error={errorListEnvironments || errorActivities} />
      )}
    </>
  );
}
